import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useYBugApi } from 'src/context/YBugContext';
import Config from 'src/utils/config';
import { SUPPORT_EMAIL } from 'src/utils/constants';

const YBugFloatingButton = ({ position = 'right', style = {} }) => {
  const yBugApi = useYBugApi();

  const isYBugAvailable = yBugApi && Config.yBugId;

  const handleSupport = () => {
    // If YBug is available, open the feedback form
    if (isYBugAvailable) {
      // Use the default 'open()' method without specifying 'feedback'
      // This shows the initial selection modal instead of the full form
      yBugApi.open();
    } else {
      // Otherwise, as an alternative, trigger an email to the support team
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Report an Issue`;
    }
  };

  const buttonClassName = classNames('ybug-floating-button', `ybug-floating-button--${position}`);

  return (
    <button
      type='button'
      className={buttonClassName}
      style={style}
      aria-label='Support'
      onClick={handleSupport}
    >
      <div className='ybug-floating-button__icon-wrapper'>
        <FontAwesomeIcon icon={faQuestion} className='ybug-floating-button__icon' />
      </div>
    </button>
  );
};

YBugFloatingButton.propTypes = {
  position: PropTypes.oneOf(['left', 'right']),
  style: PropTypes.object,
};

export default YBugFloatingButton;
